import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { SAVE, SUBMIT } from "../../constants/constants";
import useForm from "../../hooks/common/useForm";
import useSet from "../../hooks/common/useSet";
import { formHooks } from "../../hooks/handlers/formHooks";
import { RenderForm } from "../../utils/formUtils";
import { stringify } from "../../utils/helpers";
import { Button } from "../common/Button";
import { TFormHook } from "../../@types/common";

export const ModalForm = ({
  show,
  dismiss,
  button,
  state,
  source,
  id,
  title,
}: any) => {
  const [mount, setMount] = useState(true);

  const handleClose = () => {
    if (dismiss) return dismiss();
  };

  return (
    <React.Fragment>
      <Dialog
        open={show}
        onClose={handleClose}
        scroll="paper"
        fullWidth={true}
        sx={{ zIndex: 1000 }}
        keepMounted={mount}
      >
        {/* CHILDREN */}
        <ModalFormHandler
          id={id}
          source={source}
          handleClose={handleClose}
          state={state}
          dismiss={dismiss}
        />
      </Dialog>
    </React.Fragment>
  );
};

const ModalFormHandler = ({ handleClose, source, id, state, dismiss }: any) => {
  const { uploadData, error, setError, submitting, success } = useSet();
  const { form, updateFormValues, onChange, validateForm } = useForm();

  const hook = formHooks?.[source];
  const {
    title,
    fields,
    onSubmit: formSubmit,
    submitText,
    defaultValues,
    allowSubmit = true,
  }: TFormHook = hook
    ? hook({
        form,
        updateFormValues,
        source,
        state,
      })
    : {};

  function onSubmit() {
    if (validateForm(fields, setError)) {
      if (formSubmit) {
        // cleanup data
        const payload = { ...form };

        let upload_data = formSubmit({ payload, id, dismiss });

        // handle submission
        if (upload_data) {
          uploadData(upload_data);
        }
      }
    }
  }

  // RESPONSE HANDLING
  useEffect(() => {
    if (success) {
      handleClose();
    }
  }, [success]);

  // SET DEFAULTS
  useEffect(() => {
    if (defaultValues) {
      updateFormValues(defaultValues);
    }
  }, []);

  return (
    <>
      {/* TITLE */}
      <DialogTitle>
        <div
          className="capitalize font15 bold textDark"
          style={{ lineHeight: 1.2 }}
        >
          {stringify(title || source)}
        </div>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers={true} sx={{ minHeight: 200 }}>
        <div className="flexColumn gap15">
          {RenderForm({
            fields,
            form,
            updateFormValues,
            onChange,
            error,
          })}
        </div>
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions>
        <Button type="text" onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={submitting} onClick={onSubmit} disabled={!allowSubmit}>
          {submitText ? submitText : id ? SAVE : SUBMIT}
        </Button>
      </DialogActions>
    </>
  );
};
